import { Table } from 'appkit-react';

const SuccessResult = ({ fileName, successData, columns }) => (
    <>
        {!fileName && successData.length > 0 ? (
            <>
                <Table
                    data={successData}
                    columns={columns}
                    defaultPageSize={10}
                    sortable
                    size="lg"
                    resizable
                    className="-striped -highlight ReactTable rt-expander"
                    style={{ marginTop: '1rem' }}
                />
            </>
        ) : (
            <div
                className="a-h6"
                style={{
                    backgroundColor: '#F2F2F2',
                    color: '#7D7D7D',
                    padding: '0.5rem 0.5rem',
                    borderRadius: '3px',
                    width: '100%',
                    textAlign: 'center',
                    borderColor: '#f5c6cb',
                    marginTop: '1rem',
                }}
            >
                No success data found for this operation.
            </div>
        )}
    </>
);

export default SuccessResult;
